import { InternalContactsListMember } from '../../../../components/Contact/InternalContact';

export function TBMContactInternalContacts() {
  return <InternalContactsListMember />;
}
